import React, { useContext } from 'react';
import { useFormContext } from 'react-hook-form';
import { PaymentIcon, PaymentBlock } from 'anf-core-react';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import { maskCardNumber } from '../../../tools/creditCard';
import GiftCardApplied from './GiftCard/GiftCardApplied';
import Tmnt from '../../Tmnt/Tmnt';
import MaskedGiftCard from '../../Common/GiftCards/MaskedGiftCard';
import AddressCard from '../AddressCard/AddressCard';

function PaymentOverview() {
  const { formState } = useFormContext();
  const { checkoutPageState } = useContext(CheckoutPageContext);
  const {
    creditCard = [],
    billingAddressSameAsShipping,
    addresses,
  } = formState?.values || {};
  const selectedPaymentType = checkoutPageState?.selectedPaymentType || '';
  const selectedSavedPayment = checkoutPageState?.selectedSavedPayment || null;
  const selectedPayment = checkoutPageState?.paymentOptions?.find(
    (option) => option.type?.toLowerCase() === selectedPaymentType,
  );
  const giftCardsApplied = checkoutPageState?.giftCards?.appliedGiftCards;
  const tmntData = checkoutPageState?.textFor || {};

  // Render applied gift cards
  const renderGiftCardsApplied = () => (
    <div className="giftcard-info-wrapper" data-testid="giftcard-info-wrapper">
      {giftCardsApplied?.map((giftCardApplied) => (
        <GiftCardApplied
          key={giftCardApplied?.maskedNumber}
          giftCard={giftCardApplied}
          tmntData={tmntData}
          hasRemoveButton={false}
        />
      ))}
    </div>
  );

  // Render payment details
  const renderPaymentDetails = () => {
    let selectedPaymentIcon = selectedPayment?.icon;
    let maskedNumber = '';
    const selectedPaymentName = selectedPayment?.name;
    const {
      cardNumber = '', cardExpiryFmt = '', paymentCode = '021',
    } = creditCard[0] || {};

    let cardExpiryDate = cardExpiryFmt;
    const isCCPayment = selectedPayment?.type === 'credit card';
    if (isCCPayment) {
      selectedPaymentIcon = paymentCode;
      maskedNumber = maskCardNumber(cardNumber, 'X');
    }
    if (selectedSavedPayment) {
      selectedPaymentIcon = selectedSavedPayment?.iconCode;
      maskedNumber = selectedSavedPayment?.maskedCardNumber || '';
      cardExpiryDate = `${selectedSavedPayment?.cardExpiryMonth}/${selectedSavedPayment?.cardExpiryYear}`;
    }

    return (
      <div className="payment-info-wrapper" data-testid="payment-info-wrapper">
        <PaymentBlock
          paymentIcon={
            <PaymentIcon iconName={selectedPaymentIcon} labelText={selectedPaymentName} />
          }
        >
          <div className="payment-label_primary">
            <p>
              {isCCPayment ? <MaskedGiftCard giftcard={{ maskedNumber }} /> : selectedPaymentName}
            </p>
          </div>
          {isCCPayment && (
            <div className="payment-label_secondary">
              <p>
                <Tmnt tmnt={tmntData?.expText} />
                {`: ${cardExpiryDate}`}
              </p>
            </div>
          )}
        </PaymentBlock>
      </div>
    );
  };

  // Render billing address details
  const renderBillingAddress = () => {
    const billingAddress = addresses?.billing || {};

    const postalCode = billingAddress?.postalCode || billingAddress?.zip || '';
    const address = {
      ...billingAddress,
      postalCode,
    };

    return (
      <div className="billing-address">
        <AddressCard address={address} isCountryVisible />
      </div>
    );
  };

  return (
    <div className="payment-overview">
      {!!giftCardsApplied?.length && renderGiftCardsApplied()}
      {selectedPayment && renderPaymentDetails()}
      <div className="billing-info-wrapper" data-testid="billing-info-wrapper">
        <h4><Tmnt tmnt={tmntData?.billingAddress} /></h4>
        {/* Render the billing address details,
          If billingAddressSameAsShipping is true, render TMNT */}
        {billingAddressSameAsShipping
          ? <Tmnt tmnt={tmntData?.billedToShippingAddress} />
          : renderBillingAddress()}
      </div>
    </div>
  );
}

export default PaymentOverview;
